import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema } from "../shared";

// Schema
export const extracurricularSchema = itemSchema.extend({
  organization: z.string(),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  summary: z.string(),
  url: z.any(),
});

// Type
export type Extracurricular = z.infer<typeof extracurricularSchema>;

// Defaults
export const defaultExtracurricular: Extracurricular = {
  ...defaultItem,
  organization: "",
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
